// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { useState } from "react";
import { UOMHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import Statepopup from "../popup-containers/Statepopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import * as XLSX from "sheetjs-style";
import Loader from "../ReusableComponents/Loader";
import TextArea from "../ReusableComponents/TextArea";
import UOMPopup from "../popup-containers/UOMPopup";
const UnitofMeasure = () => {
  const location = useLocation();
  const [bindUomDatasterDatas, setbindUomDatas] = useState([]);

  const [bindStateMasterExcel, setbindStateMasterExcel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [visibleSubmit, setVisibleSubmit] = useState(false);
  const [visibleAddScreenTitle, setVisibleAddScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  // View details start

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
 
  const [UOMData, setUOMData] = useState({});
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // view details end

  const [bindCountriesDD, setBindCountriesDD] = useState([]);
  const [mstStateId, setMstStateId] = useState("");
  const [commodityUOM, setcommodityUOM] = useState("");
  const [mstCommodityUOMId, setmstCommodityUOMId] = useState("");
const [uomName, setUomName] = useState("");
const [description, setDescription] = useState("");

const [uomNameError, setUomNameError] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  // search end
  const showAdd = () => {
    setVisibleAdd(true);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleTable(false);
    setVisibleSubmit(true);
    setVisibleUpdate(false);
    setVisibleAddScreenTitle(true);
  };

  const cancel = () => {
    // getStateTableDatas();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);

    setUomName("");
    setDescription("");
    setmstCommodityUOMId("");
    setcommodityUOM("");
  
    // 🔥 Clear validation errors
    setUomNameError("");
  
   
    setIsLoading(false);
  };

  useEffect(() => {
   
  }, []);

  useEffect(() => {
    // Getting language codes
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  useEffect(() => {
    // getStateTableDatas();
   // getStateTableExcelDatas(); 
    
  }, []);
  const getStateTableExcelDatas = async () => {
    try {
      setIsLoading(true);
  
      const stateRes = await BindAPI("StateAPI/BindStateExcel");
  
      setbindStateMasterExcel(stateRes.data.Table || []);
    } catch (error) {
      console.error("Error fetching Excel state data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const getStateTableDatas = async () => {
  //   try {
  //     setIsLoading(true);

  //     const [stateRes, countryRes] = await Promise.all([
  //       BindAPI("StateAPI/BindState"),
  //       BindAPI("CountryAPI/BindCountry"),
  //     ]);

  //     setbindStateMasterDatas(stateRes.data.Table);
  //     setBindCountriesDD(countryRes.data.Table);
  //   } catch (error) {
  //     console.error("Error fetching state/country data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    getUomTableDatas();
  }, []);

  const getUomTableDatas = async () => {
    try {
      setIsLoading(true);
  
      const uomRes = await BindAPI("UOMAPIAPI/BindCommodityUOM1");
  
      setbindUomDatas(uomRes?.data?.Table || []);
    } catch (error) {
      console.error("Error fetching UOM data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (rowIndex) => {
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setVisibleSubmit(false);
    setVisibleUpdate(true);
    setVisibleAddScreenTitle(false);
  
    const selectedRow = bindUomDatasterDatas[rowIndex];
  
    setmstCommodityUOMId(selectedRow.MstCommodityUOMId);
    setUomName(selectedRow.CommodityUOM);
    setDescription(selectedRow.Description || "");
  

    setUomNameError("");
  };

 


  const handleState = (rowIndex, flag) => {
    // Setting visibility in popup container
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setUOMData(bindUomDatasterDatas[rowIndex]);
  };
  // const handleExport = async() =>  {
  //   
  //   const stateRes = await BindAPI("StateAPI/BindStateExcel");
  
  //  setbindStateMasterExcel(stateRes.data.Table || []);
  //   
  //   if ( stateRes.data.Table.length === 0) {
  //     toast.error("No data available to export", {
  //       duration: 1000,
  //       position: "top-center",
  //     });
  //     return;
  //   }
  
  //   const exportData = stateRes.data.Table.map((item, index) => ({
  //     "S.No": index + 1,
  //     "Country": item.CountryName_en,      
  //     "State Name": item.StateName_en,
  //     "State Code": item.StateCode,
  //     "Created By": item.CreatedByName,
  //   }));
  
  //   const worksheet = XLSX.utils.json_to_sheet(exportData);
  
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "State Master");
  
  //   worksheet["!cols"] = Object.keys(exportData[0]).map((key) => ({
  //     wch: Math.max(
  //       key.length,
  //       ...exportData.map((row) => String(row[key] ?? "").length)
  //     ) + 2,
  //   }));
  
  //   XLSX.writeFile(workbook, "State_Master.xlsx");
  
  //   toast.success("Excel exported successfully 👍", {
  //     duration: 1000,
  //     position: "top-center",
  //   });
  // };
  const handleOpen = (isOpen) => {
    // Popup open
    setpopUpOpen(isOpen);
  };

  const createdBy = sessionStorage.getItem("createdBy");
  // const handleSubmit = async (items, flag) => {
  //   // Submit functionality
  //   setSubmitBtnDisabled(true);
  //   setIsLoading(true);
  //   // Validation end
  //   if (flag == 1 || flag == 2) {
  //     // validation start
  //     let stateValidate = "";
  //     let stateCodeValidate = "";
  //     stateValidate =
  //       state.length > 0
  //         ? /^[A-Za-z ]+$/.test(state)
  //           ? !visibleUpdate &&
  //             bindStateMasterDatas.find(
  //               (x) => x.StateName_en.toLowerCase() == state.toLowerCase()
  //             )
  //             ? "State Name already available"
  //             : ""
  //           : "Only Alphabet and space allowed"
  //         : "Enter State";

  //     stateCodeValidate =
  //       stateCode.length > 0
  //         ? /^[A-Z]{2}$/.test(stateCode)
  //           ? !visibleUpdate &&
  //             bindStateMasterDatas.find(
  //               (x) => x.StateCode.toLowerCase() == stateCode.toLowerCase()
  //             )
  //             ? "State code already available"
  //             : ""
  //           : "Enter 2 characters and should be uppercase"
  //         : "Enter State Code";
  //         setUomNameError(stateValidate);
  //         // setUomNameError(stateCodeValidate);

  //     if (stateValidate || stateCodeValidate) {
  //       setIsOpen(true);
  //     }

  //     if (!stateValidate && !stateCodeValidate) {
  //       setIsOpen(false);
  //       const languageKeys = [
  //         "ta", // Tamil
  //         "hi", // Hindi
  //         "mr", // Marathi
  //         "gu", // Gujarati
  //         "kn", // Kannada
  //         "ml", // Malayalam
  //         "te", // Telugu
  //         "bn", // Bengali
  //         "or", // Oriya
  //       ];
  //       const translatedTexts = []; // Create an array to store translations
  //       for (let i of languageKeys) {
  //         const translateText = await LanguageTranslatorAPI(state, i);
  //         translatedTexts.push(
  //           translateText.data.data.translations[0].translatedText
  //         );
  //       }
  //       const statePayload = [
  //         {
  //           stateCode: stateCode,
  //           mstStateId: mstStateId ? mstStateId : 0,
  //           mstCountryId: 1,
  //           stateNameEn: state,
  //           stateNameTa: translatedTexts[0],
  //           stateNameHi: translatedTexts[1],
  //           stateNameMr: translatedTexts[2],
  //           stateNameGu: translatedTexts[3],
  //           stateNameKn: translatedTexts[4],
  //           stateNameMl: translatedTexts[5],
  //           stateNameTe: translatedTexts[6],
  //           stateNameBn: translatedTexts[7],
  //           stateNameOr: translatedTexts[8],
  //           createdBy: createdBy,
  //           flag: flag,
  //         },
  //       ];
  //       const response = await IUDAPI(statePayload, "StateAPI/IUDState");
  //       if (flag == 1) {
  //         // Submit
  //         if (response.data.Table[0].result === "S") {
  //           toast.success("State data added successfully 👍", {
  //             duration: 1000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 1000);
  //         } else {
  //           toast.error("Failed to add State data 👎", {
  //             duration: 1000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 1000);
  //         }
  //       } else if (flag == 2) {
  //         // Update

  //         if (response.data.Table[0].result === "M") {
  //           toast.success("State data updated successfully 👍", {
  //             duration: 1000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 1000);
  //         } else {
  //           toast.error("Failed to update State data 👎", {
  //             duration: 1000,
  //             position: "top-center",
  //           });
  //           setTimeout(cancel, 1000);
  //         }
  //       }
  //     } else {
  //       setSubmitBtnDisabled(false);
  //       setIsLoading(false);
  //     }
  //   } else {
  //     const statePayload = [
  //       {
  //         MstCountryId: 1,
  //         mstStateId: bindStateMasterDatas[items].MstStateId,
  //         createdBy: createdBy,
  //         flag: flag,
  //       },
  //     ];
  //     const response = await IUDAPI(statePayload, "StateAPI/IUDState");
  //     if (flag == 3) {
  //       // Delete
  //       if (response.data.Table[0].result === "D") {
  //         toast.success("State data deleted successfully 👍", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       } else {
  //         toast.error("Failed to delete State data 👎", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       }
  //     } else if (flag == 4) {
  //       // Block
  //       if (response.data.Table[0].result === "B") {
  //         toast.success("State data blocked successfully 👍", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       } else {
  //         toast.error("Failed to block State data 👎", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       }
  //     } else if (flag == 5) {
  //       // Unblock
  //       if (response.data.Table[0].result === "UB") {
  //         toast.success("State data unblocked successfully 👍", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       } else {
  //         toast.error("Failed to unblock State data 👎", {
  //           duration: 1000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 1000);
  //       }
  //     }
  //   }
  // };

  const handleSubmit = async (items, flag) => {
    try {
      setSubmitBtnDisabled(true);
      setIsLoading(true);   // 🔥 Show loader for ALL actions
  
      if (flag === 1 || flag === 2) {
        /* ===== Validation ===== */
        let uomValidate =
          uomName.length > 0
            ? /^[A-Za-z ]+$/.test(uomName)
              ? !visibleUpdate &&
                bindUomDatasterDatas.find(
                  (x) => x.CommodityUOM?.toLowerCase() === uomName.toLowerCase()
                )
                ? "Unit of Measure already available"
                : ""
              : "Only Alphabet and space allowed"
            : "Enter Unit of Measure";
  
        setUomNameError(uomValidate);
  
        if (uomValidate) {
          setIsOpen(true);
          return;
        }
  
        const uomPayload = [
          {
            mstCommodityUOMId: mstCommodityUOMId ? mstCommodityUOMId : 0,
            commodityUOM: uomName,
            description: description,
            createdBy: parseInt(createdBy),
            flag: flag,
          },
        ];
  
        const response = await IUDAPI(uomPayload, "UOMAPIAPI/IUDCommodityUOM");
  
        if (flag === 1 && response.data.Table[0].Result === "S") {
          toast.success("Unit of Measure added successfully 👍");
        }
  
        if (flag === 2 && response.data.Table[0].Result === "M") {
          toast.success("Unit of Measure updated successfully 👍");
        }
  
        await getUomTableDatas();
        setTimeout(cancel, 800);
      } 
      else {
        /* ===== Delete / Block / Unblock ===== */
        const uomPayload = [
          {
            mstCommodityUOMId: bindUomDatasterDatas[items].MstCommodityUOMId,
            commodityUOM: "",
            description: "",
            createdBy: parseInt(createdBy),
            flag: flag,
          },
        ];
  
        const response = await IUDAPI(uomPayload, "UOMAPIAPI/IUDCommodityUOM");
  
        if (flag === 3 && response.data.Table[0].Result === "D") {
          toast.success("Unit of Measure deleted successfully 🗑️");
        }
  
        if (flag === 4 && response.data.Table[0].Result === "B") {
          toast.success("Unit of Measure blocked successfully 🚫");
        }
  
        if (flag === 5 && response.data.Table[0].Result === "UB") {
          toast.success("Unit of Measure unblocked successfully ✅");
        }
  
        await getUomTableDatas();     // 🔥 Refresh grid with loader ON
        setTimeout(cancel, 800);     // 🔥 Close popup after loader shows
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong 👎");
    } finally {
      setIsLoading(false);           // 🔥 Loader stops here for all cases
      setSubmitBtnDisabled(false);
    }
  };
  useEffect(() => {
    if (location.pathname == "/statemaster") {
      setVisibleTable(true);
      setVisibleAdd(false);
   
    }
  }, [location]);


  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
  
    try {
      const res = await BindAPI("UOMAPIAPI/BindCommodityUOM1Excel");
  
      const rows = res?.data?.Table || [];
  
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "UOM MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_commodity_uom",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "UOM MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_commodity_uom",
            description: `UOM Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }
  
      // Column headers for UOM Excel
      const UOMHeadersExcel = [
        "S.No",
        "MstCommodityUOMId",
        "Unit of Measure",
        "Description",
        "Created By",
      ];
  
      exportUOMData(UOMHeadersExcel, rows);
    } catch (error) {
      console.error("Excel export error:", error);
  
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "UOM MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_commodity_uom",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };
  // const handleExport = async () => {

  //   try {
  //     const res = await BindAPI("UOMAPIAPI/BindCommodityUOM1Excel");
  
  //     const rows = res?.data?.Table || [];
  
  //     if (rows.length === 0) {
  //       toast.error("No data available to export", {
  //         duration: 1000,
  //         position: "top-center",
  //       });
  //       return;
  //     }
  
  //     // Column headers for UOM Excel
  //     const UOMHeadersExcel = [
  //       "S.No",
  //       "MstCommodityUOMId",
  //       "Unit of Measure",
  //       "Description",
  //       "Created By",
  //     ];
  
  //     exportUOMData(UOMHeadersExcel, rows);
  //   } catch (error) {
  //     console.error("Excel export error:", error);
  //     toast.error("Failed to export Excel", {
  //       duration: 1500,
  //       position: "top-center",
  //     });
  //   }
  // };
  
  const exportUOMData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Unit of Measure Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];
  
    /* ================= HEADER ================= */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));
  
    const spacingRow = [{ v: "" }];
  
    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const baseStyle = isAlt
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};
  
      return [
        { v: index + 1, s: baseStyle },                          // S.No
        { v: row.MstCommodityUOMId || "", s: baseStyle },             // Unit of Measure
        { v: row.CommodityUOM || "", s: baseStyle },             // Unit of Measure
        { v: row.Description || "", s: baseStyle },              // Description
        { v: row.CreatedByName || "", s: baseStyle },            // Created By
      ];
    });
  
    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];
  
    const ws = XLSX.utils.aoa_to_sheet(wsData);
  
    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 6 },   // S.No
      { width: 30 },  // Unit of Measure
      { width: 30 },  // Unit of Measure
      { width: 40 },  // Description
      { width: 30 },  // Created By
    ];
  
    /* ================= BORDERS ================= */
    const applyBorders = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;
  
          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };
  
    applyBorders(ws);
  
    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Unit of Measure");
    XLSX.writeFile(wb, "Unit_of_Measure_Master.xlsx");
  
    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Unit of Measure"}
          header={UOMHeader}
          records={bindUomDatasterDatas}
          handleEdit={handleEdit}
          handleAction={handleState}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full">
          <div class="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Unit of Measure"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6">
                  <InputText
  classStar="text-red-500"
  inputType={"text"}
  title={"Unit of Measure"}
  name={"uomName"}
  content={uomName}
  controlFunc={(e) => {
    const value = e.target.value;
    setUomName(value);

    const trimmed = value.trim();
    let error = "";

    if (trimmed.length === 0) {
      error = "Enter Unit of Measure";
    } 
    else if (!/^[A-Za-z ]+$/.test(trimmed)) {
      error = "Only Alphabet and space allowed";
    } 
    else {
      // 🔥 Duplicate check while typing
      const exists = bindUomDatasterDatas.some(
        (x) =>
          x.CommodityUOM?.toLowerCase() === trimmed.toLowerCase() &&
          x.MstCommodityUOMId !== mstCommodityUOMId   // allow same when editing
      );

      if (exists) {
        error = "Unit of Measure already exists";
      }
    }

    setUomNameError(error);
  }}
  controlFuncBlur={(e) => {
    const trimmedValue = e.target.value.trim();
    setUomName(trimmedValue);

    let error = "";

    if (trimmedValue.length === 0) {
      error = "Enter Unit of Measure";
    } 
    else if (!/^[A-Za-z ]+$/.test(trimmedValue)) {
      error = "Only Alphabet and space allowed";
    } 
    else {
      const exists = bindUomDatasterDatas.some(
        (x) =>
          x.CommodityUOM?.toLowerCase() === trimmedValue.toLowerCase() &&
          x.MstCommodityUOMId !== mstCommodityUOMId
      );

      if (exists) {
        error = "Unit of Measure already exists";
      }
    }

    setUomNameError(error);
  }}
  errorMessage={uomNameError}
/>
<TextArea
  title="Description"
  name="description"
  rows={4}
  content={description}
  controlFunc={(e) => setDescription(e.target.value)}

  description="Enter a brief explanation about this category. Maximum 250 characters."
/>
                  </form>
                  <Buttons
                    addScreenTitle={visibleSubmit}
                    updateScreenTitle={visibleUpdate}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleState}
      >
        <div>
          <PopUpScreenTitle
            title="Unit of Measure"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <UOMPopup data={UOMData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default UnitofMeasure;
